const initBannerSlider = () => {
  const sliderElementSelector = ".js-banner-slider";
  const sliderElement = document.querySelector(sliderElementSelector);
  if (
    !sliderElement ||
    sliderElement.querySelectorAll(".swiper-slide").length < 1
  ) {
    return;
  }
  const slider = new Swiper(sliderElementSelector, {
    // slidesPerView: 4,
    slidesPerView: "auto",
    spaceBetween: 30,
    loop: true,
    centeredSlides: true,
    autoplay: {
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: ".js-banner-slider-next",
      prevEl: ".js-banner-slider-prev",
    },
    pagination: {
      el: ".js-banner-slider-pager",
    },
  });
  return slider;
};
document.addEventListener("DOMContentLoaded", initBannerSlider);
